import React from 'react';

const STAR_COUNT = 12;
const CENTER_X = 30;
const CENTER_Y = 20;
const ORBIT_RADIUS = 13;
const OUTER_R = 3.2;
const INNER_R = 1.3;

const starPath = (cx, cy) => {
  let d = '';
  for (let i = 0; i < 10; i++) {
    const r = i % 2 === 0 ? OUTER_R : INNER_R;
    const angle = -Math.PI / 2 + (i * Math.PI) / 5;
    const x = cx + r * Math.cos(angle);
    const y = cy + r * Math.sin(angle);
    d += `${i === 0 ? 'M' : 'L'}${x.toFixed(2)},${y.toFixed(2)} `;
  }
  return `${d}Z`;
};

const STARS = Array.from({ length: STAR_COUNT }, (_, i) => {
  const angle = (i / STAR_COUNT) * 2 * Math.PI - Math.PI / 2;
  const cx = CENTER_X + ORBIT_RADIUS * Math.cos(angle);
  const cy = CENTER_Y + ORBIT_RADIUS * Math.sin(angle);
  return starPath(cx, cy);
});

const EuFlagIcon = ({ className, style, ...rest }) => (
  <svg
    className={className}
    style={{ display: 'block', ...style }}
    viewBox="0 0 60 40"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <rect width="60" height="40" fill="#003399" />
    {STARS.map((d, i) => (
      <path key={i} d={d} fill="#FFCC00" />
    ))}
  </svg>
);

export default EuFlagIcon;
